import React, { Component } from 'react';
import PropTypes from 'prop-types';
import configData from '../../../config';
import transformDataIntoObject from '../../../utils/dataLayerHelper';
import { contentType } from '../../../constants/global';
import DOMPurify from 'isomorphic-dompurify';
import { customJsonstringify } from '../../../utils/helpers/customJsonstringify.helpers';
import GtmScriptFunction from './GTM'

class PGdataLayer extends Component {
  render() {
    const { locale, data, pageType, path: urlPath, title } = this.props;
    let path = urlPath;
    if (urlPath.indexOf('#') > -1) {
      path = urlPath.substring(0, urlPath.indexOf('#'));
    }
    let dataObject = null;
    if (locale) {
      if (
        data &&
        data.productCollection &&
        pageType === contentType.productPage
      ) {
        dataObject = transformDataIntoObject(
          pageType,
          locale,
          path,
          title,
          data.productCollection.items[0].gtin,
          data.productCollection.items[0].productName
        );
      } else if (
        pageType === contentType.homePage ||
        pageType === contentType.contentPage ||
        pageType === contentType.login ||
        pageType === contentType.registration ||
        pageType === contentType.editProfile
      ) {
        dataObject = transformDataIntoObject(pageType, locale, path, title);
      } else if (
        pageType === contentType.articlePage ||
        pageType === contentType.articleListPage
      ) {
        dataObject = transformDataIntoObject(pageType, locale, path, title);
      }
    }

    return (
      <>
        <GtmScriptFunction  interval={3.5} dataObject={dataObject}/>
      </>
    );
  }
}

PGdataLayer.propTypes = {
  locale: PropTypes.string.isRequired,
  pageType: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([PropTypes.object]),
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

PGdataLayer.defaultProps = {
  data: null,
};

export default PGdataLayer;
